module.exports = __webpack_public_path__ + "static/media/facebook.12f92f1b.svg";